import { Cart, CartItem } from "src/storefront/types/cart";
import { CartItemEvent, CartItemEventSerializer } from "src/analytics/cart_item_event_serializer";
import { StorefrontConfig } from "src/storefront/types/storefront";
import { AlertContext } from "src/components/alert";
import { Catalog } from "src/storefront/types/catalog";
import { CartWithAlertMessage } from "src/storefront/decoders";

const buildRemoveItemFromCart = (
  cart: CartWithAlertMessage | null,
  catalog: Catalog | undefined,
  config: StorefrontConfig,
  setCartItems: (cartItems: CartItem[]) => Promise<CartWithAlertMessage>,
  showAlert: AlertContext,
  pushDataEvent: (cartItemEvent: CartItemEvent) => void,
) => {
  return async (cartItemToRemove: CartItem): Promise<Cart> => {
    if (!cart)
      throw new Error("Can't remove an item from the cart without an existing cart");

    const newCart = cart.cartItems.filter(ci => ci.idTarget != cartItemToRemove.idTarget);
    const mutationResult = await setCartItems(newCart);

    if (mutationResult.alertMessage) {
      showAlert(mutationResult.alertMessage);
    }

    if (catalog) {
      const serializer = new CartItemEventSerializer(catalog, config.defaultItemsEventAttributes)

      const removeFromCartEvent = serializer.removeFromCartEvent(cartItemToRemove);
      pushDataEvent(removeFromCartEvent);
    }

    return mutationResult
  }
}

export default buildRemoveItemFromCart;
